import receivablesRouter from './receivablesManage';
import collectPayBill from './collectPayBill';
import letterOfCredit from './letterOfCredit';
import moneyDraw from './moneyDraw';

export default {
  receivablesRouter,
  collectPayBill,
  letterOfCredit,
  moneyDraw,
};
